<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import SettingsHeader from './SettingsHeader.vue';
import ConnectionsNavigation from './connections/ConnectionsNavigation.vue';
const props = defineProps({
  headerTitle: { type: String, default: '' },
  icon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  showBackButton: { type: Boolean, default: false },
  backUrl: { type: [String, Object], default: '' },
});

const { t } = useI18n();
const route = useRoute();
const hasInternalScroll = computed(() => route.name === 'settings_inbox_show');

const showSettingsHeader = computed(
  () => props.headerTitle || props.icon || props.showBackButton
);
</script>

<template>
  <div
    class="flex h-full min-h-0 w-full flex-col overflow-hidden bg-n-surface-1"
  >
    <div
      v-if="route.meta.connectionsNavigation"
      class="mx-auto w-full max-w-7xl px-4 pt-4"
    >
      <ConnectionsNavigation class="mx-auto" />
    </div>

    <SettingsHeader
      v-if="showSettingsHeader"
      :icon="icon"
      :header-title="t(headerTitle)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      class="z-20 mx-auto w-full max-w-7xl"
    />

    <div
      class="min-h-0 flex-1 px-4"
      :class="hasInternalScroll ? 'overflow-hidden' : 'overflow-y-auto pb-8'"
    >
      <router-view v-slot="{ Component }">
        <component :is="Component" v-if="!keepAlive" :key="$route.fullPath" />
        <keep-alive v-else>
          <component :is="Component" :key="$route.fullPath" />
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>
